module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/SnowFall/Nagano_SnowFall_MRI_RCP85_End.png";